'use client'

import { useParams } from 'next/navigation'
import React, { FC } from 'react'

import { useCatalogBrandsProducts } from '@/features/catalog-brands'
import { AppliedFilters } from '@/features/catalog-brands/applied-filters'
import { useBrandSectionProducts } from '@/features/catalog-brands/catalog-brands-products'
import { BrandCategoriesList } from '@/features/catalog-brands/categories'
import { Filter, useBrandFilter } from '@/features/catalog-brands/filter'
import { TitlePanel } from '@/features/catalog-shared/title-panel'

import { useMediaQueries } from '@/shared/lib/hooks/useMediaQueries'
import { PaginationNew } from '@/shared/ui/pagination-new'

import { CatalogBrandsGrid } from './catalog-grid/catalog-brands-grid'
import { DrawerFilter } from './drawer-filter/drawer-filter'

import cl from './catalog-brands.module.scss'

interface CatalogBrandsProps {
	title: string
}

export const CatalogBrands: FC<CatalogBrandsProps> = ({ title }) => {
	const params = useParams()
	const { isTablet, isMobile } = useMediaQueries()

	const brandCode = params.brand as string
	const categoryCode = Array.isArray(params.category) ? params.category[0] : (params.category as string | undefined)

	// Проверяем, является ли текущая страница страницей раздела бренда (index.tsx) или страницей категории ([...category].tsx)
	const isBrandSectionPage = !categoryCode

	// Используем адаптированный хук для брендов
	const { onFilterChange, clearFilter, filterUrl, properties } = useBrandFilter()

	// Вызываем оба хука безусловно, чтобы соблюсти правила хуков React
	const brandSectionProductsData = useBrandSectionProducts(brandCode)
	const catalogBrandsProductsData = useCatalogBrandsProducts(filterUrl, brandCode, categoryCode)

	// Выбираем нужные данные в зависимости от типа страницы
	const { getMoreProducts, products, lastPage, currentPage, loading, totalProducts } = isBrandSectionPage
		? brandSectionProductsData
		: catalogBrandsProductsData

	return (
		<div className={cl.root}>
			<TitlePanel title={title} productCount={totalProducts} isLoading={loading} />
			<div className={cl.main}>
				{!isTablet && !isMobile && (
					<div className={cl.sidebar}>
						{/* Компонент списка категорий бренда */}
						<BrandCategoriesList />
						{/* Компонент фильтра */}
						{properties && properties.length > 0 && <Filter />}
					</div>
				)}
				<div>
					<div className={cl.selectorWrap}>
						{(isTablet || isMobile) && <DrawerFilter productCount={totalProducts} />}
					</div>

					{!isTablet && !isMobile && <AppliedFilters onChange={onFilterChange} className={cl.appliedFiltersWrap} />}

					<CatalogBrandsGrid items={products} isLoading={loading} onReset={clearFilter} />

					{/* Показываем пагинацию только для страницы с товарами */}
					{lastPage > 1 && (
						<PaginationNew
							lastPage={lastPage}
							currentPage={currentPage}
							onMoreClick={getMoreProducts}
							loading={loading}
							showMoreButton
							withUrlParam
						/>
					)}
				</div>
			</div>
		</div>
	)
}
